import type { insuranceMonitorApiSpec } from "@wingspanhq/wingspan-api-types";
import { StepItem } from "../../../../../../shared/components/Steps";

type InsuranceCoverageMonitor =
  insuranceMonitorApiSpec.InsuranceCoverageMonitor;

export const getInsuranceCoverageProgressSteps = (
  insuranceCoverage: InsuranceCoverageMonitor | undefined
): StepItem[] => {
  switch (insuranceCoverage?.status) {
    case "ForceMatched":
      return [
        {
          title: "Policy match",
          status: "Warning"
        },
        {
          title: "Complete",
          status: "Pending"
        }
      ];
    case "Complete":
      return [
        {
          title: "Policy match",
          status: "Complete"
        },
        {
          title: "Complete",
          status: "Complete"
        }
      ];
    default:
      return [
        {
          title: "Policy match",
          status: "Active"
        },
        {
          title: "Complete",
          status: "Pending"
        }
      ];
  }
};
